import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import './LoginPage.css';
import { API_BASE_URL } from './config';
import { FaEye, FaEyeSlash } from "react-icons/fa";

function ResetPasswordPage() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setError('Invalid reset link. Please request a new password reset.');
        }
    }, [token]);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError('');

        // Validation
        if (!token) {
            setError('Invalid reset link. Please request a new password reset.');
            return;
        }

        if (!password || !confirmPassword) {
            setError('Please fill all fields.');
            return;
        }

        if (password.length < 8) {
            setError('Password must be at least 8 characters long.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/reset-password-token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.message || 'Password reset failed. The link may have expired.');
            } else {
                setSuccess(true);
                // Redirect to login after 3 seconds
                setTimeout(() => {
                    navigate('/member/loginPage');
                }, 3000);
            }
        } catch (err) {
            setError('Network error. Please try again.');
        }
        setLoading(false);
    };

    if (success) {
        return (
            <div className="login-page-container">
                <section className="page-title-area">
                    <div className="container">
                        <div className="page-title-content">
                            <h2>Password Reset Successful</h2>
                        </div>
                    </div>
                </section>

                <section className="user-area-style login-area">
                    <div className="container">
                        <div className="login-form-action">
                            <div className="section-title">
                                <h2>Success!</h2>
                                <p style={{ color: '#15c015eb', fontSize: '18px', marginTop: '20px' }}>
                                    Your password has been reset successfully.
                                </p>
                                <p style={{ marginTop: '20px' }}>
                                    Redirecting to login page...
                                </p>
                                <div style={{ marginTop: '30px' }}>
                                    <Link to="/member/loginPage" className="submit-button" style={{ textDecoration: 'none', display: 'inline-block' }}>
                                        Go to Login
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className="login-page-container">
            {/* Header */}
            <header className="main-header">
                {/* Keep your existing header */}
            </header>

            <section className="page-title-area">
                <div className="container">
                    <div className="page-title-content">
                        <h2>Reset Password</h2>
                    </div>
                </div>
            </section>

            <section className="user-area-style login-area">
                <div className="container">
                    <div className="login-form-action">
                        <div className="section-title">
                            <h2>Reset Your Password</h2>
                            <h2>VIRON.NETWORK</h2>
                        </div>

                        {!token ? (
                            <div>
                                <p style={{ color: '#D00000', marginBottom: '20px' }}>
                                    Invalid reset link. Please contact an administrator to request a new password reset.
                                </p>
                                <Link to="/member/loginPage" className="submit-button" style={{ textDecoration: 'none', display: 'inline-block' }}>
                                    Go to Login
                                </Link>
                            </div>
                        ) : (
                            <form onSubmit={handleResetPassword}>
                                <div className="form-group" style={{ position: "relative" }}>
                                    <input
                                        className="form-control"
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Enter new password (min. 8 characters)"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        required
                                        minLength={8}
                                    />
                                    <span onClick={() => setShowPassword(p => !p)} style={{ position: "absolute", right: "20px", top: "50%", cursor: "pointer" }}>
                                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                                    </span>
                                </div>
                                <div className="form-group" style={{ position: "relative" }}>
                                    <input
                                        className="form-control"
                                        type={showConfirmPassword ? "text" : "password"}
                                        placeholder="Confirm new password"
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                        required
                                        minLength={8}
                                    />
                                    <span onClick={() => setShowConfirmPassword(p => !p)} style={{ position: "absolute", right: "20px", top: "50%", cursor: "pointer" }}>
                                        {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                                    </span>
                                </div>
                                {error && <div className="login-error">{error}</div>}
                                <button className="submit-button" type="submit" disabled={loading}>
                                    {loading ? 'Please wait...' : 'Reset Password'}
                                </button>
                                <div className="col-12">
                                    <div className="login-action text-center">
                                        <span className="forgot-login">
                                            <Link to="/member/loginPage">Back to Login?</Link>
                                        </span>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </section>

            <footer className="main-footer">
                <div className="container footer-content">
                    <div className="footer-section logo-section">
                        <img src="https://viron.network/assets/img/viron-logo-footer.svg" alt="VIRON.NETWORK" />
                    </div>

                    <div className="footer-section navigation-section">
                        <h3 class="black-text">Navigation</h3>
                        <ul>
                            <li>
                                <a href="https://viron.network/index.html" className="nav-link">Home</a>
                            </li>
                            <li>
                                <a href="https://viron.network/about" className="nav-link">About Us</a>
                            </li>
                            <li>
                                <a href="https://viron.network/works" className="nav-link">How It Works</a>
                            </li>
                            <li>
                                <a href="https://viron.network/team" className="nav-link">Meet Our Team</a>
                            </li>
                            <li>
                                <a href="https://viron.network/mission" className="nav-link">Our Mission</a>
                            </li>
                            <li>
                                <a href="https://viron.network/testimonials" className="nav-link">Testimonial</a>
                            </li>
                            <li>
                                <a href="https://viron.network/contact" className="nav-link">Contact Us</a>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-section access-section">
                        <h3 class="black-text">Access</h3>
                        <ul>
                            <li><a href="https://viron.network/registration" className="footer-button register-footer-button">Register</a></li>
                        </ul>
                    </div>

                    <div className="footer-section social-media-section">
                        <h3 class="black-text">Social Media</h3>
                        <ul className="social-icons">
                            <li><a href="#"><i className="bx bxl-facebook"></i></a></li>
                            <li><a href="#"><i className="bx bxl-instagram"></i></a></li>
                            <li><a href="#"><i className="bx bxl-youtube"></i></a></li>
                            <li><a href="#"><i className="bx bxl-twitter"></i></a></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="container copy-right">
                        <p class=" ">Copyright &copy; 2025 VIRON.NETWORK. All rights reserved.</p>
                        <p class=" ">
                            <Link to="/member/faq"><b>FAQ</b></Link> | <Link to="/privacy-policy"><b>Privacy Policy</b></Link> | <Link to="/disclaimer"><b>Disclaimer</b></Link> | <Link to="/terms-of-use"><b>Terms of Use</b></Link> | <Link to="/service-agreement"><b>Service Agreement</b></Link>
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default ResetPasswordPage;

